import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const BankingName = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 450px;
  gap: 8px;
  padding: 32px 20px;
  background: ${COLORS.white};
  border-radius: 10px;

  .close-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    cursor: pointer;
  }

  .content-container {
    .icon {
      width: 64px;
      height: 64px;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .confirmation-cta-container {
      display: flex;
      justify-content: flex-start;
      gap: 8px;
      align-items: center;
      .share-message-copy-popup {
        font: 14px;
      }
      .details-copy-icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .marginBottom {
      margin-bottom: 32px;
    }

    .__heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      margin: 8px 0;
    }
    .__description {
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      margin-bottom: 32px;
    }
    .__consentBox {
      border-radius: 4px;
      border: 1px solid ${COLORS.borderGrey};
      padding: 16px;
      font-size: 12px;
      line-height: 18px;
      font-family: ${FONT_FAMILY.hellix.regular};
      color: ${COLORS.textGrey};
      background-color: ${COLORS.lightShadedGrey};
      text-align: center;
      margin: 32px 0 12px;
    }
    .__noMarginTop {
      margin-top: unset;
    }
    .__secondaryCTAContainer {
      margin-top: 24px;
    }
  }
`;
